// ContractorSidebar.jsx
import NestedMenu from "components/Shared/NestedMenu";
import React from "react";

const ContractorSidebar = () => {
  const menuItems = [
    {
      title: "Dashboard",
      path: "/app/contractor/dashboard",
      icon: "DashboardOutlined",
    },
    {
      title: "Available Jobs",
      path: "/app/contractor/shipments",
      icon: "WorkOutlineOutlined",
    },
    {
      title: "My Shipments",
      path: "/app/contractor/myShipments",
      icon: "PersonOutlined",
    },
    {
      title: "My Drivers",
      path: "/app/contractor/drivers",
      icon: "PersonOutlined",
    },
    {
      title: "My Vehicles",
      path: "/app/contractor/vehicles",
      icon: "PersonOutlined",
    },
    {
      title: "Announcement",
      path: "/app/contractor/announcement/list",
      icon: "CampaignOutlined",
    },
  ];

  return <NestedMenu menu={menuItems} initiallyOpenedMenu="Sales" />;
};

export default ContractorSidebar;
